module.exports = __webpack_public_path__ + "img/dropdown-blue.914714b9.svg";